import { Check, Minus } from "lucide-react";

const qty = (n, unit) => (n === -1 ? "Ilimitado" : `${n} ${unit}${n > 1 ? "s" : ""}`);
const has = (plan, text) => plan.features.some((f) => f.toLowerCase().includes(text));

const ROWS = [
  { label: "Painéis de TV ao mesmo tempo", value: (p) => qty(p.limits.tvs, "TV") },
  { label: "Salas / consultórios", value: (p) => qty(p.limits.rooms, "sala") },
  { label: "Usuários da equipe", value: (p) => qty(p.limits.team, "usuário") },
  { label: "Chamada por voz (pt-BR)", value: () => true },
  { label: "Fila e histórico de chamados na TV", value: () => true },
  { label: "Imagens na TV", value: (p) => p.limits.media },
  { label: "Vídeos, YouTube e TV ao vivo na TV", value: (p) => p.limits.video },
  { label: "Relatórios de atendimento", value: (p) => p.limits.reports },
  { label: "Importar listas (Excel/CSV)", value: (p) => p.limits.bulk_import },
  { label: "Multiunidade", value: (p) => has(p, "multiunidade") },
  { label: "Suporte prioritário", value: (p) => has(p, "suporte prioritário") },
  { label: "Onboarding e treinamento", value: (p) => has(p, "onboarding") },
];

function Cell({ v, dark }) {
  if (v === true) return <Check className={`w-5 h-5 mx-auto ${dark ? "text-gold" : "text-gold"}`} />;
  if (!v) return <Minus className={`w-4 h-4 mx-auto ${dark ? "text-cream/30" : "text-cappuccino/40"}`} />;
  return <span className="font-semibold">{v}</span>;
}

export const PlanComparison = ({ plans }) => (
  <div className="mt-16" data-testid="plan-comparison">
    <h3 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight mb-2">Compare os planos</h3>
    <p className="text-cappuccino mb-6">Tudo o que cada plano inclui, lado a lado.</p>
    <div className="overflow-x-auto border border-cappuccino/20 bg-white">
      <table className="w-full min-w-[640px] text-sm" data-testid="plan-comparison-table">
        <thead>
          <tr className="border-b border-cappuccino/20">
            <th className="text-left font-heading font-semibold text-cappuccino px-5 py-4 w-[34%]">Recurso</th>
            {plans.map((p) => (
              <th key={p.id} className={`font-heading font-bold text-base px-4 py-4 text-center ${p.highlight ? "bg-ink text-cream" : "text-ink"}`}>
                {p.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROWS.map((row, i) => (
            <tr key={row.label} className={`border-b border-cappuccino/10 last:border-0 ${i % 2 ? "bg-cream/40" : ""}`}>
              <td className="px-5 py-3.5 text-ink">{row.label}</td>
              {plans.map((p) => (
                <td key={p.id} data-testid={`compare-${p.id}-${i}`}
                  className={`px-4 py-3.5 text-center ${p.highlight ? "bg-ink text-cream" : "text-ink"}`}>
                  <Cell v={row.value(p)} dark={p.highlight} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
